import { render, staticRenderFns } from "./UserInfoWebpartTest.vue?vue&type=template&id=2f6b8e1a"
import script from "./UserInfoWebpartTest.vue?vue&type=script&lang=js"
export * from "./UserInfoWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports